import 'whatwg-fetch';
import { useState } from 'react';

var BASE_URL = 'https://submit-form.com';
var useFormspark = function useFormspark(args) {
  var _useState = useState(false),
    submitting = _useState[0],
    setSubmitting = _useState[1];
  var submit = function submit(payload) {
    return new Promise(function (resolve, reject) {
      var url = BASE_URL + "/" + args.formId;
      var method = 'POST';
      var headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      };
      var body = JSON.stringify(payload);
      setSubmitting(true);
      fetch(url, {
        method: method,
        headers: headers,
        body: body
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        resolve(json);
      })["catch"](function (error) {
        reject(error);
      })["finally"](function () {
        setSubmitting(false);
      });
    });
  };
  return [submit, submitting];
};

export { useFormspark };
//# sourceMappingURL=use-formspark.esm.js.map
